angular.module('cian.districtBrowser').factory('DistrictBrowserService', ['$http', $http => {
  const service = {};

  const getLocationId = region => region.mainTownId || region.id;

  service.getDistrictsTree = region => {
    return $http.get(`/api/geo/get-districts-tree/?locationId=${getLocationId(region)}`, { cache: true });
  };

  return service;
}]);



// WEBPACK FOOTER //
// ./src/components/district-browser/src/scripts/cian.district-browser.service.js